import { useEffect, useState } from 'react';
import { getRegions } from 'services/api';
import type { AppSelectOption } from 'shared/UI/UIKit/Select';

export const getRegionOptions = async (): Promise<AppSelectOption[]> => {
  const response = await getRegions();
  return response.content.map((region) => ({
    label: region.name,
    value: region.id,
  }));
};

export const useRegions = () => {
  const [regions, setRegions] = useState<AppSelectOption[]>([]);
  const [loading, setLoading] = useState(false);

  const loadRegions = async () => {
    setLoading(true);
    try {
      const regionOptions = await getRegionOptions();
      setRegions(regionOptions);
    } catch (error) {
      console.error('Failed to load regions:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRegions();
  }, []);

  return {
    regions,
    loading,
    loadRegions,
  };
};
